<template>
  <div class="m-appbar">
    <div class="m-appbar__row">
      <router-link
        v-if="backTo"
        :to="backTo"
        class="m-appbar__back"
        :aria-label="backLabel"
        :title="backLabel"
      >
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
      </router-link>
      <div class="m-appbar__title">
        <h1>{{ title }}</h1>
        <small v-if="subtitle">{{ subtitle }}</small>
      </div>
      <div class="m-appbar__actions">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
/**
 * Barra superior de las pantallas mobile: título (+ subtítulo), volver (`backTo`) y
 * acciones como íconos. El slot por defecto va debajo (buscador, chips). Mientras está,
 * <body> lleva `m-has-appbar` y la miga de pan se oculta (la barra ya dice dónde estás).
 */
export default {
  name: "MobileAppBar",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    backTo: { type: [String, Object], default: null },
    backLabel: { type: String, default: "Back" },
  },
  mounted() {
    document.body.classList.add("m-has-appbar");
  },
  beforeDestroy() {
    document.body.classList.remove("m-has-appbar");
  },
};
</script>

<style scoped>
.m-appbar {
  position: sticky;
  top: 0;
  z-index: 20;
  margin: 0 -0.5rem;
  padding: 0.5rem 0.75rem 0.4rem;
  background: var(--m-surface);
  color: var(--m-text);
  border-bottom: 1px solid var(--m-border);
}
.m-appbar__row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-height: 2.75rem;
}
.m-appbar__title {
  flex: 1;
  min-width: 0;
  line-height: 1.2;
}
.m-appbar__title h1 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--m-text);
  /* hasta dos renglones: los números de operación son largos */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.m-appbar__back {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  margin-left: -0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--m-text);
  font-size: 1.05rem;
}
.m-appbar__back:active {
  background: var(--m-pressed);
}
.m-appbar__title small {
  color: var(--m-muted);
  font-size: 0.8rem;
}
.m-appbar__actions {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
}
</style>
